import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { blue } from '@mui/material/colors';
import './style.css';

const Billboard = ({ alignItems, body, Icon, title }) => (
    <Stack className="coe__billboard" alignItems={ alignItems } justifyContent="center" direction="column">
        {
            Icon ? 
                <Icon sx={{ color: blue[ 500 ] }} /> :
                null
        }
        <Typography variant="h1" id="top">
            { title }
        </Typography>
        <Typography id="top">
            { body }
        </Typography>
    </Stack>
)

Billboard.propTypes = {
    Icon: PropTypes.oneOfType([ PropTypes.func, PropTypes.object ]),
    alignItems: PropTypes.string,
    body: PropTypes.string,
    title: PropTypes.string
}

export default Billboard;